export const ItemTypes = {
  FOLDER: 'folder',
};
